import { useAuth } from '@/contexts/AuthContext';

/**
 * Permission helper hook for imperative checks in components. Backend RLS/authz
 * remains authoritative; these checks only gate what the UI offers.
 */
export function usePermission() {
  const { hasPermission, hasAnyPermission, hasAllPermissions, hasRole, user } = useAuth();
  return {
    can: hasPermission,
    canAny: hasAnyPermission,
    canAll: hasAllPermissions,
    hasRole,
    permissions: user?.permissions ?? [],
    roles: user?.roles ?? [],
  };
}
